import request from "@utils/request";

export function getRawHistory (query) {
    return request({
        url: "search/history",
        method: "post",
        data: query
    });
}